module.exports = __webpack_public_path__ + "img/me1.b11c7168.jpg";